import supabase from "@/auth/Client";
import { exitViewAs, isViewingAs } from "@/auth/viewAs";
import { OffLogo } from "@/components/shared/OffLogo";
import { SignupButtons } from "@/components/Signup/SignupButtons";
import { Center, Stack, Title, useMantineTheme } from "@mantine/core";

type Props = {};

/**
 * This is the page that give the users the option between logging in or starting the personality test
 */
export function SignupPage({}: Props) {
  const theme = useMantineTheme();

  const logout = async () => {
    if (isViewingAs()) {
      exitViewAs();
      return;
    }

    const { error } = await supabase.auth.signOut();
    if (error) {
      console.error(error);
    }
  };

  return (
    <Stack h="100%" justify="space-between" pb="lg" px="xl">
      <Center>
        <OffLogo />
      </Center>
      <Title ta="center" order={1} size="2.5rem" lh="1.5" style={{ wordBreak: "keep-all" }}>
        나와 잘 맞는 새로운 사람들과 새로운 장소를 탐험하는 가장 자연스러운 방법
      </Title>
      <Stack align="center" gap="md" pb="md">
        <SignupButtons />
      </Stack>
    </Stack>
  );
}
